import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import ButtonLink from '../common/ButtonLink';

import commonStyles from '../common/Styles';

const styles = (theme) => ({
  header: {
    lineHeight: '32px',
    display: 'flex',
    '& > a': {
      marginTop: 4,
      marginBottom: 4,
      marginRight: 8,
      width: 24,
      height: 24,
      color: 'inherit',
    },
    '& > h2': {
      fontSize: 24,
      display: 'inline-block',
      fontWeight: 400,
      marginTop: 0,
      // marginBottom: 0,
    }
  },
  form: commonStyles(theme).form,
  actionButtons: commonStyles(theme).actionButtons,
  text: commonStyles(theme).text,
});

class RegisterComplete extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div
        className={classes.form}>
        {this.props.text.split('\n').map((item, key) => <p className={classes.text} key={key}>{item}</p>)}
        {/*<p className={classes.text}>{this.props.linkHeader}</p>*/}
        {/*<a*/}
          {/*className={classes.link}*/}
          {/*href={instanceUrl}>Application Portal</a>*/}
        {/*{*/}
          {/*this.props.showStart && (*/}
          {/*<div*/}
            {/*className={classes.actionButtons}>*/}
            {/*<Button*/}
              {/*className="to-right"*/}
              {/*color="secondary"*/}
              {/*variant="contained"*/}
              {/*onClick={this.props.onComplete}>Start application</Button>*/}
          {/*</div> )*/}
        {/*}*/}
        <div
          className={classes.actionButtons}>
          <ButtonLink
            tabIndex="-1"
            color="secondary"
            variant="contained"
            to="/">Back to login</ButtonLink>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(RegisterComplete)



// WEBPACK FOOTER //
// ./src/components/RegisterComplete/index.js